import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import EstruturaController from '@/assets/ts/controller/EstruturaController';
import Processo from '@/assets/ts/interfaces/Processo';
import ProcessoController from '@/assets/ts/controller/ProcessoController';
import CurriculoPopup from '../CurriculoPopup/CurriculoPopup.vue';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

@Component({
  name: 'AddCandidatoPopup',
  components: {
    TkForm,
    EditableTable,
    CurriculoPopup,
  },
})
class AddCandidatoPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: null })
  private readonly nrProcesso: string;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-add')
  private emitAfterAdd() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private readonly DEFAULT_TITLE = 'Adicionar Candidato';

  private internalValue = false;

  private currentTab = 0;

  private formRow: any = {
    NRPROCESSO: null,
    CDPAIS: null,
    SGESTADO: null,
    CDMUNICIPIO: null,
    NRCURSO: null,
    NRAREAFORMACAO: null,
    NROCUPACAOM: null,
  };

  private fieldsData = {
    estadosCivis: [],
    nacionalidades: [],
    cursos: [],
    areasFormacao: [],
    idiomas: [],
    ocupacoes: [],
    paises: [],
    estados: [],
    cidades: [],
  };

  private loading = {
    add: false,
    candidatos: false,
    loaded: false,
    estadosCivis: false,
    nacionalidades: false,
    cursos: false,
    areasFormacao: false,
    idiomas: false,
    ocupacoes: false,
    paises: false,
    estados: false,
    cidades: false,
  }

  private grid = {
    columns: [
      {
        value: 'NMPESSOA',
        text: 'Nome',
      },
      {
        value: 'IDADE',
        text: 'Idade',
      },
      {
        value: 'NMGRAUINSTR',
        text: 'Grau de Instrução',
      },
      {
        value: 'LOCALIDADE',
        text: 'Localidade',
      },
    ] as EditableTableColumn[],
    rows: [] as any[],
    selected: [] as any[],
  };

  private curriculoPopup = {
    show: false,
    url: null,
  };
  // #endregion

  // #region [ COMPUTED ]
  private get isLoading(): boolean {
    const loadingValues = Object.values(this.loading);
    const internalLoading = Util.oneTrue(...loadingValues);
    return internalLoading;
  }

  private get cardTitle(): string {
    return this.DEFAULT_TITLE;
  }

  private get isInFilterTab(): boolean {
    return this.currentTab === 0;
  }

  private get form() {
    return {
      fields: [
        {
          name: 'NMPESSOA',
          label: 'Nome',
          type: 'text',
          size: 12,
        },
        {
          name: 'EMAIL',
          label: 'Email',
          type: 'text',
          size: 6,
        },
        {
          name: 'DTNASCPESSOA',
          label: 'Data de Nascimento',
          type: 'date',
          hideDatePicker: true,
          size: 3,
        },
        {
          name: 'IDADE',
          label: 'Idade',
          type: 'number',
          size: 3,
        },
        {
          name: 'IDADEMINIMA',
          label: 'Idade Mínima',
          type: 'number',
          size: 3,
        },
        {
          name: 'IDADEMAXIMA',
          label: 'Idade Máxima',
          type: 'number',
          size: 3,
        },
        {
          name: 'SALARIOMINIMO',
          label: 'Salário Mínimo',
          type: 'number',
          size: 3,
        },
        {
          name: 'SALARIOMAXIMO',
          label: 'Salário Máximo',
          type: 'number',
          size: 3,
        },
        {
          name: 'IDSEXOPESSOA',
          label: 'Sexo',
          type: 'select',
          size: 3,
          descriptionField: 'description',
          valueField: 'value',
          items: [
            {
              value: 'M',
              description: 'Masculino',
            },
            {
              value: 'F',
              description: 'Feminino',
            },
          ],
        },
        {
          name: 'IDCADASTROCOMPLETO',
          label: 'Cadastro Completo?',
          type: 'select',
          size: 3,
          descriptionField: 'description',
          valueField: 'value',
          items: [
            {
              value: 'S',
              description: 'Sim',
            },
            {
              value: 'N',
              description: 'Não',
            },
          ],
        },
        {
          name: 'CDESTACIVIL',
          label: 'Estado Civil',
          type: 'autocomplete',
          size: 6,
          descriptionField: 'NMESTACIVIL',
          valueField: 'CDESTACIVIL',
          items: this.fieldsData.estadosCivis,
          loading: this.loading.estadosCivis,
        },
        {
          name: 'NRNACIONALID',
          label: 'Nacionalidade',
          type: 'autocomplete',
          size: 6,
          descriptionField: 'DSNACIONALIDADE',
          valueField: 'NRNACIONALIDADE',
          items: this.fieldsData.nacionalidades,
          loading: this.loading.nacionalidades,
        },
        {
          name: 'IDPOSSUIFILHO',
          label: 'Filhos?',
          type: 'select',
          size: 3,
          descriptionField: 'description',
          valueField: 'value',
          items: [
            {
              value: 'S',
              description: 'Sim',
            },
            {
              value: 'N',
              description: 'Não',
            },
          ],
        },
        {
          name: 'DSINSTITUICAO',
          label: 'Instituição',
          type: 'text',
          size: 12,
        },
        {
          name: 'NRCURSO',
          label: 'Curso',
          type: 'autocomplete',
          size: 6,
          descriptionField: 'NMCURSO',
          valueField: 'NRCURSO',
          items: this.fieldsData.cursos,
          loading: this.loading.cursos,
        },
        {
          name: 'DSCURSO',
          label: 'Outro Curso',
          type: 'text',
          size: 6,
          readonly: this.formRow.NRCURSO !== '2',
        },
        {
          name: 'NRAREAFORMACAO',
          label: 'Área de Formação',
          type: 'autocomplete',
          size: 6,
          descriptionField: 'NMAREAFORMACAO',
          valueField: 'NRAREAFORMACAO',
          items: this.fieldsData.areasFormacao,
          loading: this.loading.areasFormacao,
        },
        {
          name: 'DSAREAFORMACAO',
          label: 'Outra Área de Formação',
          type: 'text',
          size: 6,
          readonly: this.formRow.NRAREAFORMACAO !== '2',
        },
        {
          name: 'NROCUPACAOM',
          label: 'Ocupação',
          type: 'autocomplete',
          size: 6,
          descriptionField: 'NMOCUPACAOH',
          valueField: 'NROCUPACAOM',
          items: this.fieldsData.ocupacoes,
          loading: this.loading.ocupacoes,
        },
        {
          name: 'DSOCUPACAO',
          label: 'Outra Ocupação',
          type: 'text',
          size: 6,
        },
        {
          name: 'CDPAIS',
          label: 'País',
          type: 'autocomplete',
          size: 4,
          descriptionField: 'NMPAIS',
          valueField: 'CDPAIS',
          items: this.fieldsData.paises,
          loading: this.loading.paises,
          onInput: this.paisOnSelect,
        },
        {
          name: 'SGESTADO',
          label: 'Estado',
          type: 'autocomplete',
          size: 4,
          descriptionField: 'NMESTADO',
          valueField: 'SGESTADO',
          items: this.fieldsData.estados,
          loading: this.loading.estados,
          readonly: !this.formRow.CDPAIS,
          onInput: this.estadoOnSelect,
        },
        {
          name: 'CDMUNICIPIO',
          label: 'Cidade',
          type: 'autocomplete',
          size: 4,
          descriptionField: 'NMMUNICIPIO',
          valueField: 'CDMUNICIPIO',
          items: this.fieldsData.cidades,
          loading: this.loading.cidades,
          readonly: !this.formRow.SGESTADO,
        },
      ] as Field[],
    };
  }

  private get loadingGrid(): boolean {
    return this.loading.candidatos || this.loading.add;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    //
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.value) {
      this.currentTab = 0;
    }

    if (!this.loading.loaded) {
      this.loadFieldsData();
    }
  }

  @Watch('nrProcesso', { immediate: true })
  private nrProcessoOnChange(): void {
    this.formRow.NRPROCESSO = this.nrProcesso;
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog(): void {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private async loadCandidatos(): Promise<void> {
    this.loading.candidatos = true;
    this.grid.rows = [];
    this.grid.selected = [];

    try {
      this.grid.rows = await ProcessoController.getCandidatosGeral(this.formRow, false);
    } finally {
      this.loading.candidatos = false;
    }
  }

  private rowOnClick(candidato: any): void {
    this.gerarCurriuloCandidato(candidato);
  }

  private async gerarCurriuloCandidato(candidato: any): Promise<void> {
    const nrOrg = candidato.NRORG;
    const nrParcNegocio = candidato.NRPARCNEGOCIO;

    const link = await ProcessoController.generateResume(
      nrOrg, nrParcNegocio
    );

    this.curriculoPopup.show = true;
    this.curriculoPopup.url = link;
  }

  private goToFilterTab(): void {
    this.currentTab = 0;
  }

  private searchCandidatos(): void {
    this.currentTab = 1;
    this.loadCandidatos();
  }

  private loadFieldsData(): void {
    this.loadEstadosCivis();
    this.loadNacionalidades();
    this.loadCursos();
    this.loadAreasFormacao();
    this.loadOcupacoes();
    this.loadPaises();

    this.loading.loaded = true;
  }

  private async loadEstadosCivis(): Promise<void> {
    this.loading.estadosCivis = true;

    try {
      this.fieldsData.estadosCivis = await AdmissaoController.getEstadocivil(false);
    } finally {
      this.loading.estadosCivis = false;
    }
  }

  private async loadNacionalidades(): Promise<void> {
    this.loading.nacionalidades = true;

    try {
      this.fieldsData.nacionalidades = await AdmissaoController.getNacionalidade(false);
    } finally {
      this.loading.nacionalidades = false;
    }
  }

  private async loadCursos(): Promise<void> {
    this.loading.cursos = true;

    try {
      this.fieldsData.cursos = await AdmissaoController.getCursoAcademico(false);
    } finally {
      this.loading.cursos = false;
    }
  }

  private async loadAreasFormacao(): Promise<void> {
    this.loading.areasFormacao = true;

    try {
      this.fieldsData.areasFormacao = await AdmissaoController.getAreaFormacao(false);
    } finally {
      this.loading.areasFormacao = false;
    }
  }

  private async loadOcupacoes(): Promise<void> {
    this.loading.ocupacoes = true;

    try {
      this.fieldsData.ocupacoes = await AdmissaoController.getOcupacao(false);
    } finally {
      this.loading.ocupacoes = false;
    }
  }

  private async loadPaises(): Promise<void> {
    this.loading.paises = true;

    try {
      this.fieldsData.paises = await AdmissaoController.getPais(false);
    } finally {
      this.loading.paises = false;
    }
  }

  private async loadEstados(): Promise<void> {
    const cdPais: string = this.formRow.CDPAIS;

    if (!cdPais) {
      return;
    }

    this.loading.estados = true;

    try {
      this.fieldsData.estados = await AdmissaoController.getEstado(cdPais, false);
    } finally {
      this.loading.estados = false;
    }
  }

  private async loadCidades(): Promise<void> {
    const cdPais: string = this.formRow.CDPAIS;
    const sgEstado: string = this.formRow.SGESTADO;

    if (!cdPais || !sgEstado) {
      return;
    }

    this.loading.cidades = true;

    try {
      this.fieldsData.cidades = await AdmissaoController.getMunicipio(cdPais, sgEstado, false);
    } finally {
      this.loading.cidades = false;
    }
  }

  private paisOnSelect(): void {
    this.formRow.SGESTADO = null;
    this.formRow.CDMUNICIPIO = null;

    this.loadEstados();
  }

  private estadoOnSelect(): void {
    this.formRow.CDMUNICIPIO = null;

    this.loadCidades();
  }

  private async addCandidatos(): Promise<void> {
    if (this.grid.selected.length === 0) {
      const message = 'Selecione ao menos 1 candidato!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);
      return;
    }

    this.loading.add = true;

    try {
      await ProcessoController.addCandidatos(
        this.nrProcesso,
        this.grid.selected,
        false,
      );

      const message = 'Candidatos adicionados com sucesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);

      this.emitAfterAdd();
      this.closeDialog();
    } finally {
      this.loading.add = false;
    }
  }

  private goBack(): void {
    if (this.grid.selected.length > 0) {
      const message = 'Os candidatos selecionados foram desmarcados.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_INFO2);
    }

    this.goToFilterTab();
  }
  // #endregion
}

export default AddCandidatoPopup;
